<template>
  <div class="row mb-4">
    <div class="col-12 col-md-8 col-lg-5">
      <sign-up-sign-in></sign-up-sign-in>
    </div>
  </div>
</template>

<script>
import SignUpSignIn from "@/components/signUpSignIn/index.vue";

export default {
  components: { SignUpSignIn }
};
</script>
